export default defineAppConfig({
  membershipLayer: {},
});

declare module "@nuxt/schema" {
  interface AppConfigInput {
    membershipLayer?: {};
  }
}
